import { generateErrorMessage } from '../../utils/error-message';
import { isNewErrorMessagingFlagActive } from '../../utils/error-message-flag';

export type TAcquisitionFieldProps = {
    name: string;
    id: string;
    label?: string;
    isValid: (val: any) => boolean;
    invalidErrorMessage: string;
};

/**
 * This object holds the input props for all the acquisition input fields.
 * It only includes attributes and properties that are uniform to all acquisition flows.
 *
 * Variations can be designated using PA, PQ, SPQ followed by the page (i.e. PADE, PQApp, etc...)
 *
 * Fields can be referenced as follows:
 * <InputBase {...acquisitionFieldProps.appovalCode} />
 */
export const acquisitionFieldProps: Record<string, TAcquisitionFieldProps> = {
    approvalCode: {
        name: 'approvalCode',
        id: 'approvalCodeInput',
        isValid: (val: string) => {
            return val.replace(/\D/g, '').length === 10;
        },
        invalidErrorMessage: isNewErrorMessagingFlagActive ? 'Enter your approval code from your offer' : 'Less than 10 digits',
    },
    zipCode: {
        name: 'zipCode',
        id: 'zipCodeInput',
        isValid: (val: string) => {
            return val.replace(/\D/g, '').length === 5;
        },
        invalidErrorMessage: isNewErrorMessagingFlagActive ? generateErrorMessage('ZIP Code', 'missingValue') : 'Less than 5 digits',
    },
};


export type TAcquisitionFormData = {
    value: string;
    validState: boolean;
    hasBeenInteractedWith: boolean;

}
export const PADEFields = ['approvalCode', 'zipCode'];

/**
 * Returns a new form data object containing all the passed fields.
 * Example:
 * // will returns { a: {value: '', valideState: true}, b: {value: '', valideState: true}}
 * getFormData(['a', 'b']);
 * @param fields
 */
export const getFormData = (fields: string[]) => {
    const formData: Record<string, TAcquisitionFormData> = {};
    fields.forEach((name) => {
        formData[name] = { value: '',  validState: true, hasBeenInteractedWith: false };
    });

    return formData;
};
